// extracted by mini-css-extract-plugin
module.exports = {"shadow":"bottom-bar_shadow__mYxok","textShadow":"bottom-bar_textShadow__EEGcr","holder":"bottom-bar_holder__3V8tn","element":"bottom-bar_element__1Rv4k"};